<template>
    <div>
        <keen-category-selector
            :label="label"
            root-category-label="Expense Categories"
            :provider="categoryProvider"
            :search-enabled="true"
            :disabled="disabled"
            :keys="{ value: 'id', label: 'name', children: 'children' }"
            :display-name-formatter="displayNameFormatter"
            :clearable="clearable"
            v-model="selected"
            @input="handleChange"
        />
    </div>
</template>

<script>    
    import { ExpenseCategoryResource } from '../../../classes/Api/Expense'

    export default {
        props: {
            label: {
                type: String,
                default() {
                    return 'Expense Category'
                } 
            },
            value: {
                type: Object,
                default: null,
            },
            disabled: {
                type: Boolean,
                default() {
                    return false;
                }
            },
            showCategoryPath: {
                type: Boolean,
                default: true,
            },
            clearable: {
                type: Boolean,
                default: false,
            }
        },
        created() {
            if (this.value) {
                this.selected = this.value;
            }
        },
        watch: {
            value(newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.selected = newVal;
                }
            }
        },
        data() {
            return {
                selected: {},
            }
        },
        methods: {
            displayNameFormatter(category) {
                if (!this.showCategoryPath) {
                    return category.name
                }

                return category.label
            },
            categoryProvider(currentCategory = null, searchQuery = null) {
                return new Promise((resolve, reject) => {
                    if (searchQuery) {
                        ExpenseCategoryResource.all({ query: searchQuery }).then(response => {
                            resolve(response.data.filter(item => item.is_user_selectable))
                        }, e => { handleApiError(e); reject(e); })
                    } else if (!currentCategory) {
                        ExpenseCategoryResource.all({ root_only: true }).then(response => {
                            resolve(response.data.filter(item => item.is_user_selectable))
                        }, e => { handleApiError(e); reject(e); })
                    } else {
                        ExpenseCategoryResource.find(currentCategory.id).then(response => {
                            resolve(response.data.children.filter(item => item.is_user_selectable))
                        }, e => { handleApiError(e); reject(e); })
                    }
                })
            },
            handleChange(e) {
                this.$emit('input', e);
            }
        }
    }
</script>